export default __webpack_public_path__ + "static/default_og_image-fcc48d4150d04687ec39d5e2e1b8ea89.jpg";